import { useEffect } from "react";

// Defaults from public/index.html, restored when a page with its own meta unmounts.
const SITE = "North of Six Club";
const SITE_URL = "https://northofsixclub.com";
const DEFAULT_DESCRIPTION =
  "North of Six Club — a community for tall folks sharing their perfect fits.";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!href) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Per-page <title>, meta description and canonical URL. Google renders the SPA
 * before indexing, so setting these client-side is enough for search results
 * to show each product / spot under its own name instead of the site default.
 * Pass a null title while data is loading to leave the defaults in place.
 */
export const usePageMeta = (title, description) => {
  useEffect(() => {
    if (!title) return undefined;
    document.title = `${title} | ${SITE}`;
    setMeta("description", description || DEFAULT_DESCRIPTION);
    // Canonical drops query strings (utm tags, share params) so they aren't indexed as duplicates.
    setCanonical(SITE_URL + window.location.pathname);
    return () => {
      document.title = SITE;
      setMeta("description", DEFAULT_DESCRIPTION);
      setCanonical(null);
    };
  }, [title, description]);
};

// Trim to Google's ~155-char snippet length on a word boundary.
export const snippet = (text, max = 155) => {
  const s = String(text || "").replace(/\s+/g, " ").trim();
  if (s.length <= max) return s;
  return s.slice(0, s.lastIndexOf(" ", max - 1)).replace(/[,.;:]$/, "") + "…";
};
